import React, { useState, useEffect } from "react";
import { Hide, Show } from "react-iconly";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { Facebook, Google } from "react-bootstrap-icons";
import "./signUp.scss";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import {
  login,
  checkgooglemail,
  googleLoginApi,
} from "../../services/auth.service";
import LoginAs from "../loginAs/LoginAs";
import { GoogleLogin } from "@react-oauth/google";
import { googleLogout, useGoogleLogin } from "@react-oauth/google";

import { useSelector, useDispatch } from "react-redux";
// import { login, logout, selectUser } from './authSlice';
import { loginr, logout } from "../../slice/authSlice";
import { toast_success, toast_warning } from "../../config/Constant";
import {
  checkEmail,
  fbLogin,
  checkEmailGoogle,
  GoogleLoginCheck,
} from "../../services/auth.service";
// import FacebookLogin from "react-facebook-login";
import { async } from "q";
import localStorage from "redux-persist/es/storage";
// import { getFcmToken } from "../../config/firebaseConfig";
import { isVisible } from "@testing-library/user-event/dist/utils";
const SignUp = (props) => {
  // ****************************js**************************************************************
  let navigate = useNavigate();
  // const [fcmToken, setFcmToken] = useState("");
  const [input, setInput] = useState({});
  const [errors, setErrors] = useState({}); //Add state variables for form data and validation errors.
  const [loading, setLoading] = useState(false);
  const [rember, setRember] = useState(false);


  useEffect(() => {

    const fetchData = async () => {

      let storedEmail = await localStorage.getItem('loginemail');
      let storedPassword = await localStorage.getItem('loginpassword');

      if (storedEmail && storedPassword) {

        setInput({
          email: (storedEmail) || "",
          password: (storedPassword) || "",
        });

        setRember(true); // Set the 'Remember me' checkbox checked
      }


      // const storedFcmToken = await getFcmToken();

      // // Check if the token is available
      // if (storedFcmToken) {
      //   setFcmToken(storedFcmToken);
      //   // Use the token as needed
      // } else {
      //   // Handle the case when the token is not available
      // }
    };

    // Call the fetchData function
    fetchData();
  }, []);

  const dispatch = useDispatch();

  // const handleFacebookResponse = async (response) => {
  //   if (response.accessToken) {
  //     const accessToken = response.accessToken;
  //     // Call your backend API to perform Facebook login
  //     // Pass the accessToken to your backend for validation and user authentication
  //     // Example using fetch:
  //     const result = await facebookLogin(accessToken);
  //   }
  // };

  const responseFacebook = async (response) => {
    if (response.status == "unknown") {
    } else {
      const checkAvailble = await checkEmail(response.accessToken);
      if (checkAvailble?.data?.data?.registered == true) {
        props.setSignUpModal(false);

        const payload = {
          email: checkAvailble.data.data.data.email,
          // fcmToken: fcmToken,
          deviceType: "web",
          // deviceId: "deedid",
        };

        const result = await fbLogin(payload);
        localStorage.removeItem("facebookData");
        await dispatch(loginr(result.data));
        localStorage.setItem("accessToken", result.data.token);

        if (result.data.userType === "provider") {
          navigate("/provider/dashboard");
        } else if (result.data.userType === "user") {
          navigate("/");
        }
      } else {
        localStorage.setItem("facebookData", JSON.stringify(response));
        props.setLoginAsModal(true);
        props.setSignUpModal(false);
      }
    }

    // if(response.accessToken){
    //   const res = await facebookLogin(response.accessToken)
    //   localStorage.setItem("facebookData",JSON.stringify(res.data.data))
    // }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      try {
        const payload = {
          ...input,
          // fcmToken: fcmToken,
          deviceType: "web",
          // deviceId: "deedid",
        };
        if(rember){
          localStorage.setItem('loginemail',input.email);
          localStorage.setItem('loginpassword',input.password);
        }else{
          localStorage.setItem('loginemail',"");
          localStorage.setItem('loginpassword',"");
        }
        setLoading(true);
        const res = await login(payload);

        if (res?.data?.status === true) {
          toast.success(res?.data?.message, toast_success);

          await dispatch(loginr(res.data));
          localStorage.setItem("accessToken", res.data.token);
          props.setSignUpModal(false);

          if (res.data.userType === "provider") {
            navigate("/provider/dashboard");
          } else if (res.data.userType === "user") {
            navigate("/");
          }
        } else {
          toast.warning(res?.response?.data?.message, toast_warning);
        }
      } catch (e) {
      } finally {
        // Set loading back to false when API call completes
        setLoading(false);
      }
    }
  };

  const redirect = () => {
    // setLoginAsModal(true)
    // setHideModel(true)
    props.setForgotPassworSignUpdModal(true);
    props.setSignUpModal(false);
  };

  // ***** ******************************************google login code start **************************
  const [isVisible, setVisiblePass] = useState(false);
  const [profile, setProfile] = useState([]);

  const googleLogin = useGoogleLogin({
    onSuccess: async (codeResponse) => {
      const checkAvailble = await checkEmailGoogle(codeResponse.access_token);
      if (checkAvailble?.data?.data?.registered == true) {
        props.setSignUpModal(false);
        const payload = {
          email: checkAvailble.data.data.data.email,
          // fcmToken: fcmToken,
          deviceType: "web",
          // deviceId: "deedid",
        };
        const result = await GoogleLoginCheck(payload);
        localStorage.removeItem("facebookData");
        await dispatch(loginr(result.data));
        localStorage.setItem("accessToken", result.data.token);

        if (result.data.userType === "provider") {
          navigate("/provider/dashboard");
        } else if (result.data.userType === "user") {
          navigate("/");
        }
      } else {
        const result = await googleLoginApi(codeResponse.access_token);
        const userData = {
          google_id: result.data.id,
          google_email: result.data.email,
          google_fname: result.data.given_name,
          lastname: result.data.family_name,
          pic: result.data.picture,
        };

        var userDataJSON = JSON.stringify(userData);
        localStorage.setItem("userData", userDataJSON);
        props.setLoginAsModal(true);
        props.setSignUpModal(false);
      }
    },
    onError: (error) => console.log("Login Failed:", error),
  });

  // useEffect(() => {
  //   if (user) {
  //     axios
  //       .get(
  //         `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${user.access_token}`,
  //             Accept: "application/json",
  //           },
  //         }
  //       )
  //       .then((res) => {
  //         setProfile(res.data);
  //         var chekdata={
  //           "email": res.data.email,
  //           "social_id": res.data.id,

  //         };

  //         checkgooglemail(chekdata)
  //           // **************************************************************************************************
  //           .then((googleData) => {
  //             if (googleData?.data?.status === true) {
  //               toast.success(googleData.data.message, {
  //                 position: toast.POSITION.TOP_CENTER,
  //               });
  //               props.setSignUpModal(false);
  //               navigate('provider/profile');
  //               // note direct login from here
  //             } else {
              //               toast.warning(googleData.data.message, {
              //                 position: toast.POSITION.TOP_CENTER,
              //               });

              //               var userDataJSON = JSON.stringify(userData);

  //               localStorage.clear();
  //               // Store the JSON string in localStorage
  //               localStorage.setItem("userData", userDataJSON);
  //               // signin modeal
  //               props.setLoginAsModal(true);
  //               props.setSignUpModal(false);
  //             }

              //             //  toast.warning(googleData.data.message, {
  //             //   position: toast.POSITION.TOP_CENTER,
  //             // });
  //             // props.setSignUpModal(false)
  //             // note direct login from here
  //             // **************************************************************************************************
  //             //  ******************************************************************************************
  //           })
  //           .catch((googleError) => {
  //             console.error("Error in checkGoogleMail:", googleError);
  //           });
  //         //  ******************************************************************************************
  //       })
  //       .catch((err) => console.log(err));
  //   }
  // }, [user]);

  // ***********************************************************google login code end **************************

  const handleChange = (e) => {
    const { name, value } = e.target;

    setInput((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear validation error for the current field
    setErrors((prev) => ({
      ...prev,
      [name]: undefined,
    }));
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = {};

    // Password length validation
    if (!input.password || input.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters long";
      valid = false;
    }
    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!input.email || !emailRegex.test(input.email)) {
      newErrors.email = "Invalid email address";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  // ****************************js code end**************************************************************

  return (
    <>
      <Modal
        size="sm"
        show={props.signUpModal}
        onHide={() => props.setSignUpModal(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="pt-0">
          <h2 className="modal-title text-center">Book your jobs from anywhere with Helpr</h2>
          <div className="modal-sub-title">
            Welcome to Helpr! We are here to help with your
            <br /> service requests.
          </div>
          <Form
            className="modal-form-wrapper"
            onSubmit={(e) => handleSubmit(e)}
            enctype="multipart/form-data"
          >
            <Form.Group className="mb-3" controlId="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="text"
                name="email"
                value={input.email}
                onChange={handleChange}
                placeholder="Enter your email address"
              />
              {errors.email && (
                <span style={{ color: "red" }}>{errors.email}</span>
              )}
              {/* <div className="error-message">Enter Email</div> */}
            </Form.Group>

            <Form.Group className="mb-3" controlId="password">
              <Form.Label>Password</Form.Label>
              <div className="form-wrap">
                <Form.Control
                  type={isVisible ? "text" : "password"}
                  name="password"
                  onChange={handleChange}
                  placeholder="Enter your password"
                  value={input.password}
                />
                <div className="icon-wrap">
                  {isVisible ? (
                    <Show onClick={() => setVisiblePass(!isVisible)} />
                  ) : (
                    <Hide onClick={() => setVisiblePass(!isVisible)} />
                  )}
                </div>
              </div>
              {errors.password && (
                <span style={{ color: "red" }}>{errors.password}</span>
              )}
            </Form.Group>

            <Form.Group className="mb-3" controlId="termsCondition">
              <div className="d-flex w-100 align-items-center gap-1 form-check-wrapper justify-content-between">
                <div className="d-flex">
                  <Form.Check
                    className="mb-0"
                    type="checkbox"
                    id=""
                    label="Remember me"
                    checked={rember}
                    onChange={()=>setRember(!rember)}
                  />
                </div>
                <div
                  onClick={() => {
                    props.setForgotPasswordModal(true);
                    props.setSignUpModal(false);
                  }}
                >
                  <span> Forgot password?</span>
                </div>
              </div>
            </Form.Group>
            {/* <Form.Group className="mb-4">
              <div className="d-grid">
                <Button type="submit" variant="primary" size="lg">
                  Sign In
                </Button>
              </div>login
            </Form.Group> */}
            {loading ? (
              <div className="loader-container">
                <div className="loader"></div>
              </div>
            ) : (
              <Form.Group className="mb-4">
                <div className="d-grid">
                  <Button type="submit" variant="primary" size="lg">
                    Sign In
                  </Button>
                </div>
              </Form.Group>
            )}
            <div className="form-footer text-center w-100 mb-4">
              Don’t have an account?{" "}
              <span
                onClick={() => {
                  props.setLoginAsModal(true);
                  props.setSignUpModal(false);
                }}
              >
                Create an account
              </span>
            </div>
            {/* <div className="divider mb-4">
              {" "}
              <span>Or</span>
            </div> */}

            <div className="social-login-wrap d-flex flex-column w-100 mb-3">
               <div className="d-grid">
                <Button
                  type="button"
                  variant="outline-primary"
                  size="lg"
                  onClick={() => googleLogin()}
                >
                  <i>
                    <Google />
                  </i>{" "}
                  Log In with Google
                </Button>
              </div>
              {/* <div className="w-100  facebook-btn">
                <FacebookLogin
                  // appId="276829254972614"
                  appId="1171439247412976"
                  // autoLoad={true}
                  fields="name,email,picture"
                  scope="public_profile,email,user_friends"
                  cssClass="btn btn-outline-primary"
                  callback={responseFacebook}
                  icon={<Facebook />}
                />
              </div>  */}
              {/* <FacebookLogin
                      appId={"1183465342408192"}
                      fields="name,email"
                      callback={handleFacebookResponse}
                      onFailure={handleFacebookResponse}
                      render={(renderProps) => (
                        <button
                          style={{
                            background: "#4267B2",
                            color: "#fff",
                            padding: "3px 8px", // Adjusted padding
                            borderRadius: "3px",
                            border: "none",
                            cursor: "pointer",
                            fontSize: "15px", // Adjusted font size
                            height: "45px", // Adjusted height
                          }}

                        >
                          Login with Facebook
                        </button>
                      )}
                    /> */}

              {/* <div className="d-grid">
                <Button type="button" variant="outline-primary" size="lg">
                  <i>
                    <Facebook />
                  </i>{" "}
                  Log in with Facebook
                </Button>
              </div> */}
             </div>
          </Form>
        </Modal.Body>
      </Modal>
      {/* {loginAsModal ? <LoginAs setLoginAsModal={setLoginAsModal} loginAsModal={loginAsModal} /> : ''} */}
    </>
  );
};

export default SignUp;
